import * as yup from "yup"

export const validationSchema = yup.object().shape({
  signUpFirstName: yup.string().required("First name is required."),
  signUpEmail: yup.string().email("Email is invalid").required("Email is required."),
})
